<template>
  <div>
    <div class="banner"></div>
    <div :class="{ 'product-serve': true, 'fadeInUp': product }" id="product">
      <div v-show="product">
        <h2>产品中心</h2>
        <div class="small-text">PRODUCTS CENTER</div>
      </div>
    </div>

    <div class="jiaodai" id="jiaodai">
      <div v-show="jiaodai_animation" :class="{ 'img-parent': true, 'fadeInLeft': jiaodai_animation }">
        <img class="img" :src="jiaodai" />
      </div>
      <div v-show="jiaodai_animation" :class="{ 'introduct': true, 'fadeInRight': jiaodai_animation }">
        <div class="commit-tit">
          <h3>氢气泄漏检测胶带 ZN-H₂-2022</h3>
          <!-- <div class="small-text">DIGITAL MANAGEMENT PLATFORM</div> -->
        </div>
        <div class="text">
          <!-- <h5>氢能产业链数字孪生平台</h5> -->
          氢气泄漏检测胶带是一种专门用于检测氢气泄漏的工具，具有使用方便、反应迅速等优点。适用多种环境，可广泛应用于氢气生产、运输、储存和输送设施等领域，在氢气泄漏时迅速反应，改变颜色，以便及时发现泄漏并采取必要的措施，可以有效地保护设备和人员的安全，避免氢气泄漏造成的事故和损失，是保障氢能安全使用的重要工具之一。
        </div>
      </div>
    </div>

    <div class="strip">
      <div class="fenxian" id="fenxian">
        <div v-show="fenxian_animation" :class="{ 'introduct': true, 'fadeInLeft': fenxian_animation }">
          <div class="commit-tit">
            <h3>氨气泄漏检测胶带 ZN-NH₃-2022</h3>
            <!-- <div class="small-text">DIGITAL MANAGEMENT PLATFORM</div> -->
          </div>
          <div class="text ">
            氨气泄漏检测胶带是一种用于检测氨气泄漏的特殊胶带。它通常由聚合物材料制成，具有高度吸附氨气的能力。氨气泄漏检测胶带的使用非常简便。当怀疑有氨气泄漏时，将胶带贴附在可能泄漏的区域，如管道接口、阀门或容器表面。胶带会吸附氨气，如果泄漏存在，胶带的颜色会发生变化，由白色变为紫色，以示警示。
          </div>
        </div>
        <div v-show="fenxian_animation" :class="{ 'introduct': true, 'fadeInRight': fenxian_animation }">
          <img class="img" :src="jiaodai2" style="float: right;">
        </div>
      </div>
    </div>


    <div class="fenxian2" id="fenxian2">
      <div v-show="fenxian2_animation" :class="{ 'img-parent': true, 'fadeInLeft': fenxian2_animation }">
        <img class="img" :src="fenxian2" />
      </div>
      <div v-show="fenxian2_animation" :class="{ 'introduct': true, 'fadeInRight': fenxian2_animation }">
        <div class="commit-tit">
          <h3>安全风险管理系统</h3>
          <!-- <div class="small-text">DIGITAL MANAGEMENT PLATFORM</div> -->
        </div>
        <div class="text">
          <!-- <h5>氢能产业链数字孪生平台</h5> -->
          安全风险管理系统是针对氢能各种使用场景进行安全生产监控的综合管理系统,针对各目标场景定制的设备台账、智慧派单、风险识别、大数据分析、安全档案等核心模块组成,该套系统可有效帮助客户对全业务场景进行安全监控与防范。
        </div>
      </div>
    </div>


    <div class="strip">
      <div class="taijia" id="taijia">
        <div v-show="taijia_animation" :class="{ 'introduct': true, 'fadeInLeft': taijia_animation }">
          <div class="commit-tit">
            <h3>140MPa超高压宽温域氢气密封性能检测平台</h3>
            <!-- <div class="small-text">DIGITAL MANAGEMENT PLATFORM</div> -->
          </div>
          <div class="text">
            <p>140MPa超高压宽温域氢气密封性能检测平台的整体研制从增压系统、温控系统、密封检测系统等主要功用出发，突破了超高压与宽温域控制的设计瓶颈，并通过功能模块、元器件、管路的设计实现各环节间的有效连接。</p>
            <p>由两个20尺集装箱组成，一个设置为操控区域，一个设置为测试区域。</p>
            <p>检测平台整体占地面积达到194.53平方米。</p>
          </div>
        </div>
        <div v-show="taijia_animation" :class="{ 'introduct': true, 'fadeInRight': taijia_animation }">
          <img class="img" :src="taijia">
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="solution">
      <div :class="{ 'commit-tit': true, 'fadeInUp': solutionTitle }" id="solutionTitle">
        <h3 v-show="solutionTitle">解决方案</h3>
        <div v-show="solutionTitle" class="small-text">Total Solution</div>
      </div>
      <div :class="{ 'solution-content': true }" id="solutionContent">

        <p v-show="solutionContent" :class="{ 'fadeInUp': solutionContent }">
          解决方案集成智能监控、风险识别、智能巡检、数据采集、数据建模、数据挖掘等诸多功能，结合检测胶带与AI智能视频识别技术，基于“建档一识别一实施一修复一报告”的核心逻辑，搭建安全风险管理系统。
        </p>
        <p v-show="solutionContent" :class="{ 'fadeInDown': solutionContent }">
          对目标设备氢气泄漏点位进行氢气泄漏检测胶带布施，对布施点位进行编码标记，信息录入系统，设定AI摄像头定时拍照周期，对其进行全生命周期监控，建立安全风险管理台账，实现分级分类巡检，提升场站安全系数以及人工巡检效率。
        </p>
        <p v-show="solutionContent" :class="{ 'fadeInDown': solutionContent }">
          该解决方案适用于制氢、储氢、运氢、加氢等用氢全产业链，为运营方提供检测点全生命周期的安全监控和场站数字化运营方案。
        </p>
        <img v-show="solutionContent" :class="{ 'fadeInRight': solutionContent }" :src="k1"
          style="width:100%;height:611px" />
      </div>
    </div>
    <div :class="{ 'product-serve': true, 'fadeInUp': aboutUs }" id="aboutUs">
      <div v-show="aboutUs">
        <h2>关于我们</h2>
        <div class="small-text">About Us</div>
      </div>
    </div>
    <!-- 公司简介 -->

    <div class="introduce">
      <div :class="{ 'commit-tit': true, 'fadeInUp': introduceTitle }" id="introduceTitle">
        <h3 v-show="introduceTitle">公司简介</h3>
        <div v-show="introduceTitle" class="small-text">Company Profile</div>
      </div>
      <div :class="{ 'introduce-content': true, 'fadeInUp': introduceContent }" id="introduceContent">
        <p v-show="introduceContent">
          北京中能航科科技有限公司，是一家专业从事氢安全业务的高科技企业，伴随国家双碳战略，公司以集团资源平台及国内外知名高校、科研院所为依托，致力于为行业提供安全、高效的氢气泄漏检测/密封解决方案，目前已经形成氢安全风险管理系统，检测台架及传感器，密封解决方案开发等产品线。我们的检测技术和产品已经得到了国内外客户的广泛认可和信赖，被广泛应用于石油化工、航空航天、能源等领域。我们秉承“以客户为中心，以技术为核心”的理念，不断推进技术创新和产品升级，为客户提供更加优质的产品和服务。
        </p>
        <img v-show="introduceContent" :src="introduce" style="width:100%;height: auto;" />
      </div>
    </div>
    <!-- 荣誉资质 -->
    <div class="strip">
      <div class="honors">
        <div :class="{ 'commit-tit': true, 'fadeInUp': honorsTitle }" id="honorsTitle">
          <h3 v-show="honorsTitle">荣誉资质</h3>
          <div v-show="honorsTitle" class="small-text">Qualifications and Honors</div>
        </div>
        <div :class="{ 'introduce-content': true, 'fadeInLeft': honorsContent }" id="picList">
          <div v-for="(item, index) in picArr" v-if="honorsContent" :key="index"
            :class="{ 'rotation-item': true, 'active1': item.scale == 0.6, 'active2': item.scale == 0.8, 'active3': item.scale == 1 }"
            :style="{ 'left': item.left + '%' }">
            <el-image :src="item.url"></el-image>
          </div>
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="partners">
      <div :class="{ 'commit-tit': true, 'fadeInDown': partnersTitle }" id="partnersTitle">
        <h3 v-show="partnersTitle">合作伙伴</h3>
        <div v-show="partnersTitle" class="small-text">Cooperative partner</div>
      </div>
      <div :class="{ 'introduce-content': true, 'fadeInDown': partnersContent }" id="partnersList">
        <ul v-if="partnersContent">
          <li v-for="(item, index) in partnersList" :style="{ 'left': item.left + '%' }">
            <el-image :src="item.url"></el-image>
          </li>
        </ul>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      bannerUrl: require("@/assets/img/banner.png"),
      jiaodai: require("@/assets/img/jiaodai.png"),
      jiaodai2: require("@/assets/img/jiaodai2.png"),
      fenxian2: require("@/assets/img/fenxian2.png"),
      taijia: require("@/assets/img/taijia.png"),
      k1: require("@/assets/img/k1.png"),
      introduce: require("@/assets/img/introduce.png"),
      product: false,
      aboutUs: false,
      jiaodai_animation: false,
      fenxian_animation: false,
      fenxian2_animation: false,
      taijia_animation: false,
      solutionTitle: false,
      solutionContent: false,
      introduceTitle: false,
      introduceContent: false,
      honorsTitle: false,
      honorsContent: false,
      partnersTitle: false,
      partnersContent: false,
      picArr: [
        { url: require("@/assets/img/h1.png"), url2: require("@/assets/img/h1_x2.png"), left: 0, scale: 0.6 },
        { url: require("@/assets/img/h2.png"), url2: require("@/assets/img/h2_x2.png"), left: 0, scale: 0.8 },
        { url: require("@/assets/img/h3.png"), url2: require("@/assets/img/h3_x2.png"), left: 0, scale: 1 },
        { url: require("@/assets/img/h4.png"), url2: require("@/assets/img/h4_x2.png"), left: 0, scale: 0.8 },
        { url: require("@/assets/img/h5.png"), url2: require("@/assets/img/h5_x2.png"), left: 0, scale: 0.6 },
      ],
      partnersList: [
        { url: require("@/assets/img/p1.png") },
        { url: require("@/assets/img/p2.png") },
        { url: require("@/assets/img/p3.png") },
        { url: require("@/assets/img/p4.png") },
        { url: require("@/assets/img/p5.png") },
      ],
      tipIndex: 1,                 // 0-4 用于更新底部圆点  共 5个真实 li
      isChanging: false,           // 是否正在变换
      userChanging: false,         // 是否是用户触发的变换
    }
  },
  created() {

  },
  mounted() {
    if (this.$route.query.target) {
      this.product = true;
      this.aboutUs = true;
      this.jiaodai_animation = true;
      this.fenxian_animation = true;
      this.fenxian2_animation = true;
      this.taijia_animation = true;
      this.solutionTitle = true;
      this.solutionContent = true;
      this.introduceTitle = true;
      this.introduceContent = true;
      this.honorsTitle = true;
      this.honorsContent = true;
      this.partnersTitle = true;
      this.partnersContent = true;
      var t = this.$route.query.target;
      this.$nextTick(() => {
        let anchorElementHeight = document.getElementById(t).offsetTop;
        console.log(anchorElementHeight);
        var offset  = window.innerHeight/2;
        window.scrollTo({ top: anchorElementHeight-160, behavior: 'smooth' });
      });

    } else {
      this.$nextTick(() => {
        this.scroll()
        window.addEventListener('scroll', this.scroll);
      })
    }

  },
  methods: {
    scroll() {
      const elOffsetTop = document.getElementById("product").offsetTop;
      const aboutUselOffsetTop = document.getElementById("aboutUs").offsetTop;
      const docScrollTop = document.documentElement.scrollTop - 175;
      if (elOffsetTop >= docScrollTop && elOffsetTop < (docScrollTop + window.innerHeight)) {
        this.product = true;

      }
      if (aboutUselOffsetTop >= docScrollTop && aboutUselOffsetTop < (docScrollTop + window.innerHeight)) {
        this.aboutUs = true;

      }
      const jiaodai_elOffsetTop = document.getElementById("jiaodai").offsetTop;
      if (jiaodai_elOffsetTop >= docScrollTop && jiaodai_elOffsetTop < (docScrollTop + window.innerHeight)) {
        this.jiaodai_animation = true;
      }

      const fenxian_elOffsetTop = document.getElementById("fenxian").offsetTop;
      if (fenxian_elOffsetTop >= docScrollTop && fenxian_elOffsetTop < (docScrollTop + window.innerHeight)) {
        this.fenxian_animation = true;
      }

      const fenxian2_elOffsetTop = document.getElementById("fenxian2").offsetTop;
      if (fenxian2_elOffsetTop >= docScrollTop && fenxian2_elOffsetTop < (docScrollTop + window.innerHeight)) {
        this.fenxian2_animation = true;
      }

      const taijia_elOffsetTop = document.getElementById("taijia").offsetTop;
      if (taijia_elOffsetTop >= docScrollTop && taijia_elOffsetTop < (docScrollTop + window.innerHeight)) {
        this.taijia_animation = true;
      }
      //解决方案
      const solution_title_elOffsetTop = document.getElementById("solutionTitle").offsetTop;
      if (solution_title_elOffsetTop >= docScrollTop && solution_title_elOffsetTop < (docScrollTop + window.innerHeight)) {
        this.solutionTitle = true;
      }
      const solution_content_elOffsetTop = document.getElementById("solutionContent").offsetTop;
      if (solution_content_elOffsetTop >= docScrollTop && solution_content_elOffsetTop < (docScrollTop + window.innerHeight)) {
        this.solutionContent = true;
      }
      //公司简介
      const introduce_title_elOffsetTop = document.getElementById("introduceTitle").offsetTop;
      if (introduce_title_elOffsetTop >= docScrollTop && introduce_title_elOffsetTop < (docScrollTop + window.innerHeight)) {
        this.introduceTitle = true;
      }
      const introduce_content_elOffsetTop = document.getElementById("introduceContent").offsetTop;
      if (introduce_content_elOffsetTop >= docScrollTop && introduce_content_elOffsetTop < (docScrollTop + window.innerHeight)) {
        this.introduceContent = true;
      }
      //荣誉资质
      const honors_title_elOffsetTop = document.getElementById("honorsTitle").offsetTop;
      if (honors_title_elOffsetTop >= docScrollTop && honors_title_elOffsetTop < (docScrollTop + window.innerHeight)) {
        this.honorsTitle = true;
      }
      const honors_content_elOffsetTop = document.getElementById("picList").offsetTop;
      if (honors_content_elOffsetTop >= docScrollTop && honors_content_elOffsetTop < (docScrollTop + window.innerHeight)) {
        this.honorsContent = true;
      }
      //合作伙伴
      const partners_title_elOffsetTop = document.getElementById("partnersTitle").offsetTop;
      if (partners_title_elOffsetTop >= docScrollTop && partners_title_elOffsetTop < (docScrollTop + window.innerHeight)) {
        this.partnersTitle = true;
      }
      const partners_content_elOffsetTop = document.getElementById("partnersList").offsetTop;
      if (partners_content_elOffsetTop >= docScrollTop && partners_content_elOffsetTop < (docScrollTop + window.innerHeight)) {
        this.partnersContent = true;
      }
    }
  },
}
</script>

<style scoped lang="less">
.fixd {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: space-Between;
  -webkit-justify-content: space-Between;
  -moz-box-pack: space-Between;
  -ms-flex-pack: space-Between;
  justify-content: space-Between;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.banner {
  width: 100%;
  margin-top: -60px;
  height: calc(84vh);
  background: url('~@/assets/img/banner.png') no-repeat;
  background-size: 100% auto;
}

.product-serve {
  background-color: #F3F7FC;
  text-align: center;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 43px;
  padding-bottom: 43px;

  h2 {
    font-size: 48px;
    line-height: 1.4;
    color: #008cd6;
    font-weight: bold;
  }

  .small-text {
    font-size: 20px;
    line-height: 1.4;
    color: #999999;
    margin-top: 10px;
  }
}

.fadeInUp {
  animation: fadeInUp 1s;
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
}

.jiaodai,
.fenxian,
.fenxian2,
.taijia {
  padding-top: 100px;
  padding-bottom: 100px;
  width: 1000px;
  margin: 0 auto;
  .fixd();
  align-items: center;

  .introduct {
    width: 47%;

    .commit-tit {
      text-align: left;

      h3 {
        font-size: 30px;
        line-height: 1.4;
      }

      .small-text {
        font-size: 16px;
      }
    }

    .img-parent {
      width: 41%;
    }

    .text {
      font-size: 14px;
      line-height: 24px;
      color: #666;
      margin-top: 25px;
      text-align: justify;
    }
  }

  .img-parent {
    width: 41%;
  }

  .fadeInLeft {
    animation: fadeInLeft 1s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
  }

  .fadeInRight {
    animation: fadeInRight 1s;
    -webkit-animation-name: fadeInRight;
    animation-name: fadeInRight;
  }
}

.solution,
.introduce,
.honors,
.partners {
  padding-top: 60px;
  padding-bottom: 80px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  .fadeInLeft {
    animation: fadeInLeft 1s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
  }

  .commit-tit {
    text-align: center;

    h3 {
      font-size: 36px;
      line-height: 1.4;
      font-weight: bold;
      font-family: 'Oswald-DemiBold';
    }

    .small-text {
      font-size: 20px;
      line-height: 1.4;
      color: #999999;
      margin-top: 10px;
    }
  }

  .solution-content,
  .introduce-content {
    width: 1000px;
    margin: 0 auto;
    font-size: 14px;
    line-height: 24px;
    color: #666;
    margin-top: 25px;
    text-align: justify;

    p {
      margin-bottom: 23px;
    }

  }

  #picList {
    width: 840px;
    height: 300px;
    overflow: hidden;

    .rotation-item {
      position: relative;
      float: left;

      .el-image {
        height: 280px;
        width: 200px;
      }

    }

    .active2 {
      left: 6px;
      right: 6px;

      .el-image {
        margin-top: 30px;
        height: 250px;
        width: 170px;

      }
    }

    .active1 {
      .el-image {
        margin-top: 50px;
        height: 230px;
        width: 150px;
      }
    }
  }

  .fadeInDown {
    animation: fadeInDown 1s;
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown;
  }

  .fadeInRight {
    animation: fadeInRight 1s;
    -webkit-animation-name: fadeInRight;
    animation-name: fadeInRight;
  }

}

.honors {
  background: url('~@/assets/img/honors2.png') no-repeat, url('~@/assets/img/honors.png') no-repeat;
  background-position-x: center, center;
  background-position-y: 90%, top;
}

.partners {
  #partnersList {
    ul {
      display: flex;
      justify-content: space-between;

      li {
        &:hover {
          scale: 1.1;
        }
      }
    }

  }

  .fadeInDown {
    animation: fadeInDown 1s;
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown;
  }
}
/deep/.partners,/deep/.honors{
  img{
    cursor:inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/home.vue